module.exports = __webpack_public_path__ + "static/automatic-ai_3-d6e3513c4c5b38c23b30e0e6214c51c2.jpg";